// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhf_a bht_h","Menu__offsetParent":"bhf_b bht_bj","Menu__trigger--shadowed":"bhf_c"};